<template>
	<div class="footBox">
		<div class="footQr clearfix">
			<div class="footQr_item">
				<img src="@/images/teacher_qr.png"/>
				<div class="footQr_itemp">教师端</div>
			</div>
			<div class="footQr_item">
				<img src="@/images/student_qr.png"/>
				<div class="footQr_itemp">学生端</div>
			</div>
		</div>
		<div class="foot">
			<div class="footLine" style="font-size: 35px;font-family: '楷体';">
				中医康复保健专业教学资源库及信息化教学平台
			</div>
			<div class="footLine">
				系统总用户数：{{numInfo.sysUserCount || 0}}人&nbsp;&nbsp;&nbsp;&nbsp;系统访问量：{{numInfo.syslogCount || 0}}次
			</div>
			<div class="footLine footLineclick pointer" @click="openUrl" v-if="indexAdShow">
				点击进入：【{{indexAdName}}】
			</div>
		</div>
	</div>
</template>

<script>
	import { systemCountStatistical } from "@/api/statistical.js"
	export default {
		name: 'footmain',
		data() {
			return {
				indexAdShow:window.config.INDEX_AD_SHOW,
				indexAdName:window.config.INDEX_AD_NAME,
				numInfo: {},
			}
		},
		created() {
			this.getNums()
		},
		mounted() {

		},
		methods: {
			openUrl(){
				window.open(window.config.INDEX_AD_URL)
			},
			getNums() {
				systemCountStatistical().then(res => {
					this.numInfo = res.data;
				})
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>